import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {AccountTrader} from "../../../model/customer/account-trader";
import {CustomerAccountTraderService} from "../../../services/customer/account-trader/customer-account-trader.service";
import {
  CustomerAccountTraderDataLoadingService
} from "../../../services/customer/account-trader/customer-account-trader-data-loading.service";
import {
  CustomerAccountTraderTableConfigService
} from "../../../services/customer/account-trader/customer-account-trader-table-config.service";
import {
  CustomerAccountTraderFormConfigService
} from "../../../services/customer/account-trader/customer-account-trader-form-config.service";
import {FieldsService} from "../../../services/common/fields-service";

@Component({
  selector: 'app-acct-trader',
  templateUrl: './account-trader.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class AccountTraderComponent extends CrudBaseComponent<AccountTrader> {

  batchUpdateDialogVisible: boolean = false;
  batchAction: "update" | "clone" = "update";

  constructor(cdref: ChangeDetectorRef,
              customerAccountTraderervice: CustomerAccountTraderService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private readonly tableConfigService: CustomerAccountTraderTableConfigService,
              private readonly formConfigService: CustomerAccountTraderFormConfigService,
              private readonly fieldsService: FieldsService,
              protected readonly dataLoadingService: CustomerAccountTraderDataLoadingService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerAccountTraderervice;
    this.newRecord = new AccountTrader();
    this.newRecord.exchangeCode = ExchangeDetail.ALL_TEXT;
    this.transPartKey = 'account-trader';
    this.fieldId = 'id';
  }

  protected initConfigs() {
    super.initConfigs();
    this.tableConfig = this.tableConfigService.loadConfig();
    this.formConfig = this.formConfigService.loadConfig(this)
    this.initButtons();
  }

  protected initButtons() {
    this.headerButtonConfig.splice(3, 0,
      {
        'tooltip': this.translateService.instant('page.' + this.transPartKey + '.table.batch_update_button'),
        'icon': 'fas fa-pen-to-square',
        class: ' p-button-help',
        command: records => this.batchUpdate(),
        enabled: () => !this.hasOneSelection() && this.hasMultipleSelection()
      },
      {
        'tooltip': this.translateService.instant('page.' + this.transPartKey + '.table.batch_clone_button'),
        'icon': 'fa-regular fa-clone cc-ico-clone-edit',
        class: ' p-button-help',
        command: records => this.batchClone(),
        enabled: () => !this.hasOneSelection() && this.hasMultipleSelection()
      },
    );
    this.headerButtonConfig = [...this.headerButtonConfig];

    this.contextMenuConfig.splice(2, 0,
      {
        id: 'batch-update',
        label: this.translateService.instant('page.' + this.transPartKey + '.table.batch_update_button'),
        icon: 'fas fa-pen-to-square',
        command: () => {
          this.batchUpdate();
        }
      },
      {
        id: 'batch-clone',
        label: this.translateService.instant('page.' + this.transPartKey + '.table.batch_clone_button'),
        icon: 'fa-regular fa-clone cc-ico-clone-edit',
        command: () => {
          this.batchClone();
        }
      }
    );
    this.contextMenuConfig = [...this.contextMenuConfig];
  }


  onFormShow() {
    this.dataLoadingService.filterCustomers(this.formRecord);
    this.dataLoadingService.filterAccounts(this.formRecord);
  }

  protected initData(): void {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.tracker = this.fieldsService.createTracker();

    this.tracker.progress.subscribe(value => {
      this.settingsFormLoadingProgressValue = value;
    });

    this.dataLoadingService.loadData(this);
  }

  private batchUpdate() {
    this.doBatchAction("update");
  }

  private batchClone() {
    this.doBatchAction("clone");
  }

  private doBatchAction(action: "update" | "clone") {
    if (this.selectedRecords && this.selectedRecords.length > 0) {
      this.formRecord = {...this.selectedRecords[0]};
    }
    this.onFormShow();

    this.batchUpdateDialogVisible = true;
    this.batchAction = action;
  }

  refreshContextMenu() {
    this.contextMenuConfig.forEach(menu => {
      if (menu.id === 'batch-update'||menu.id === 'batch-clone') {
        menu.disabled = this.hasOneSelection() || !this.hasMultipleSelection()
      }
    });
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  public onSaved() {
    this.loadRecords();
  }

}
